import _pick from 'lodash/pick';

function Ctrl($scope, $rootScope, $state, $timeout, $uibModalInstance, utilsService, jsSdkUser) {
  $scope.user = $rootScope.currentUser;

  $scope.saveUser = function() {
    const user = _pick($scope.user, ['email', 'phone']);

    jsSdkUser.updateMe(user)
      .then(resp => {
        $scope.user = resp;

        $scope.updateUserResult = 'success';
        $scope.isUpdatingUser = false;

        $uibModalInstance.dismiss(false);
      })
      .catch(() => {
        $scope.updateUserResult = 'error';
        $scope.isUpdatingUser = false;
      });
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.isUpdatingUser = null;
  $scope.updateUserResult = null;
  $scope.updateUserBtnOptions = {
    buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
    buttonDefaultText: 'Save Contact Information',
    buttonSubmittingText: 'Saving Changes...',
    buttonSuccessIcon: 'icon-left fa fa-check',
    buttonSuccessText: 'Changes Saved',
    buttonErrorIcon: 'icon-left fa fa-remove',
    buttonErrorText: 'Error Saving Changes',
    buttonErrorClass: 'animated-button-error'
  };
}

Ctrl.$inject = [
  '$scope',
  '$rootScope',
  '$state',
  '$timeout',
  '$uibModalInstance',
  'utilsService',
  'jsSdk.user'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/services/modal/editContactInformation/editContactInformationModalCtrl.js